import React, { useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import "./VuduInstructionPage.scss";
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"
import TMHFooter from "../../components/TMHFooter/TMHFooter";

export default function AmazonInstructionPage() {
    useTitle("How To Redeem Vudu Rewards - The Movie House TV")

    useEffect(() => {
        ReactGA.send("pageview")
    })

    const step2 = require('./img/step-2.png')
    const step3 = require('./img/step-3.png')
    const step2Small = require('./img/step-2-small.png')
    const step3Small = require('./img/step-3-small.png')

    return (
        <TMHBanner styleId={2} classOption="only-gradient">
            <div className="vudu-wrapper">
                <div className="box">
                    <div className="box1">
                        <div className="box-wraper">
                            <div className="block-1">
                                <div className="block-title">
                                    Select &#38; watch your Movie on Vudu
                                </div>
                                <p>1. Click below to visit Vudu and redeem the code sent to your email</p>
                                <button className="block-button">
                                    <a href="https://www.freemoviequiz.tv/code" target="_blank" rel="noreferrer">
                                        Visit Vudu now
                                    </a>
                                </button>
                                <div className="block-line" />
                            </div>

                            <div className="block-2">
                                <p>2. Enter your Promo Code into the Redemption Center field and hit “Submit”</p>
                                <div className="img-block">
                                    <img src={step2Small} alt="Step 2" />
                                </div>

                                <div className="block-line" />
                            </div>

                            <div className="block-3">
                                <p>3. Sign in or create your free Vudu account  </p>
                                <div className="block-line" />
                            </div>

                            <div className="block-4">
                                <p><b>4. Your credit value will be applied to your next purchase or rental</b></p>
                                <p>Now your complete, Vudu lets you redeem Promo Codes for new release movies on their Roku app, see below for the installation steps.</p>
                                <div className="block-line" />


                                <div className="block-title">
                                    Download the Vudu app on your Roku
                                </div>
                                <div className="block-list">
                                <p>
                                    1. On your Roku select “Search Channels” <br/>
                                    2. Type “Vudu” Select “Add Channel”<br/>
                                    3. Open up “My Channels” and open Vudu or go to the home screen to launch Vudu<br/>
                                    4. Follow the on screen prompts to sync your Vudu account with your roku <br/>
                                    5. Select and use your previously applied gift card on a new release movie <br/>
                                </p>
                                </div>
                                <div className="img-block">
                                    <img src={step3Small} alt="Step 4" />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="box2">
                        <div className="box-wraper">
                            <div className="block-1">
                                <img src={step2} alt="Step 2" />
                            </div>
                            <div className="block-2">
                                <img src={step3} alt="Step 3" />
                            </div>
                        </div>
                    </div>
                </div>
                <TMHFooter />
            </div>
        </TMHBanner>
    )
}